import { useTranslation } from "react-i18next";

import { TICKET_LISTE_GRENZE } from "@msc/shared";

import { useKpiTicketListen, type ListenAbfrage } from "../../../hooks/useKpiTickets.js";
import { TicketListeModal } from "../../tickets/TicketListeModal.js";

export interface TicketAuswahl {
  titel: string;
  abschnitte: { titel: string; abfrage: ListenAbfrage }[];
}

/**
 * Die Ticketliste hinter einem Klick in einem Ticket-Block. Jeder Abschnitt ist
 * eine eigene Abfrage mit genau der Bedingung, die die Zahl gezählt hat. Die
 * Abschnittstitel tragen die Länge der Liste — so fällt sofort auf, wenn Zahl
 * und Liste auseinanderliefen.
 */
export function TicketAuswahlModal({
  segmentId,
  auswahl,
  jiraBaseUrl,
  onClose,
}: {
  segmentId: string;
  auswahl: TicketAuswahl | null;
  jiraBaseUrl: string | null;
  onClose: () => void;
}) {
  const { t } = useTranslation();
  const listen = useKpiTicketListen(segmentId, auswahl ? auswahl.abschnitte.map((a) => a.abfrage) : null);
  const gekappt = listen.some((l) => l.data?.gekappt);
  return (
    <TicketListeModal
      opened={auswahl !== null}
      onClose={onClose}
      titel={auswahl?.titel ?? ""}
      tickets={[]}
      abschnitte={(auswahl?.abschnitte ?? []).map((a, i) => {
        const tickets = listen[i]?.data?.tickets ?? [];
        return { titel: `${a.titel} (${listen[i]?.data?.gekappt ? `> ${TICKET_LISTE_GRENZE}` : tickets.length})`, tickets };
      })}
      ohneBearbeiter
      jiraBaseUrl={jiraBaseUrl}
      laedt={listen.some((l) => l.isLoading)}
      fehler={listen.some((l) => l.isError) ? t("pages.kpi.tickets.listeFehler") : null}
      hinweis={gekappt ? t("pages.kpi.tickets.gekappt", { grenze: TICKET_LISTE_GRENZE }) : null}
    />
  );
}
